import React, { useEffect, useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import Graybg from "../../UI/Graybg";
import DataTable from "./DataTable/Table";
import userService from "../../app/services/user.service";
import { toast, ToastContainer, Zoom } from "react-toastify";
import Loader from "../../UI/loader/loader";
import AddProfile from "./AddProfile/AddProfile";
import Toast from "../../UI/Toast/Toast";

const ProfileList = () => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const [profileData, setProfileData] = useState([]);
  const [loading,setloading ] = useState(false);

  const getProfileData = ({loader}) => {
    loader && setloading(true);
    userService
      .getProfileList()
      .then((data) => {
        loader && setloading(false);
        console.log(data.data.data);
        setProfileData(data.data.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong")
        loader && setloading(false);
      });
  };
  useEffect(() => {
    getProfileData({loader:true});
  }, []);
  const updateList = (profile_name,active) => {
    getProfileData({loader:true});
    toast.success(`${profile_name} ${active ? 'deactivated' :'activated'} successfully`);
  }
  return (
    <div className="section">
    {loading && <Loader/>}
    <Toast />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Profile List</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>Profile List</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <AddProfile user_id={user_id} getProfileData={() => getProfileData({loader:false})} />
      </div>
      <Graybg>
        <DataTable profileData={profileData} updateList={updateList} />
      </Graybg>
    </div>
  );
};

export default ProfileList;
